import { getBids } from 'utils/actions/bids'
import { getMapboxEta } from 'utils/actions/mapbox'
import { getReservedOfferDetails, resetReservedOfferDetails } from 'utils/actions/reservedOffer'
import { getShipmentsCount, ACTIVE_SHIPMENTS_COUNT_ACTION_TYPES } from 'utils/actions/shipments'
import { callApi, ENDPOINTS } from 'utils/api/callApi'
import { stopsSummary } from 'utils/shipmentHelpers'
import { IN_TRANSIT_STATUSES, ASSIGNED_SHIPMENT_STATUS } from '../../constants/shipments'
import { SIDEBAR_ACTION_TYPES } from '../actions/sidebar'

const { SIDEBAR_EXTRA, SIDEBAR_OPEN, SIDEBAR_REQUESTED } = SIDEBAR_ACTION_TYPES

export const sidebar = store => next => async action => {
  if (action.type !== SIDEBAR_REQUESTED) return next(action)
  next(action)
  const { payload = {} } = action
  store.dispatch(getBids(payload.id))

  const actionWith = data => {
    const finalAction = { ...action, ...data }
    delete finalAction[payload]
    return finalAction
  }
  try {
    const shipmentRequest = {
      endpoint: ENDPOINTS.shipments,
      id: payload.id,
      params: {
        includes: [
          'driver_tracking_information',
          'shipper_insurance_requirement',
          'auto_appts',
          'project44_metadata',
          'backhaul_eligible_lanes',
        ],
      },
    }
    const {
      shipment,
      shipment: {
        info: { carrierId },
        status: { key },
      },
    } = await callApi(shipmentRequest)

    store.dispatch(getMapboxEta('SIDEBAR_ETA', shipment))

    next(
      actionWith({
        type: SIDEBAR_OPEN,
        payload: {
          ...payload,
          data: shipment,
          error: null,
        },
      })
    )

    const hasActiveShipments = [...IN_TRANSIT_STATUSES, ...ASSIGNED_SHIPMENT_STATUS].includes(key)

    if (hasActiveShipments) {
      const params = {
        filters: {
          status: [...IN_TRANSIT_STATUSES, ...ASSIGNED_SHIPMENT_STATUS],
          usersId: carrierId,
          usersType: 'carrier',
        },
      }
      store.dispatch(getShipmentsCount(params, ACTIVE_SHIPMENTS_COUNT_ACTION_TYPES))
    }

    const { delivery, pickup } = stopsSummary(shipment)

    if (['waterfall_offered', 'reserved'].includes(shipment.status.key)) {
      store.dispatch(getReservedOfferDetails(payload.id))
    } else {
      store.dispatch(resetReservedOfferDetails())
    }
    return next(
      actionWith({
        type: SIDEBAR_EXTRA,
        payload: {},
      })
    )
  } catch (error) {
    return next(
      actionWith({
        type: SIDEBAR_OPEN,
        payload: {
          ...payload,
          error,
        },
      })
    )
  }
}
